export default [
  { label: 'Season', key: 'season' },
  { label: 'Player', key: 'player' },
  { label: 'School', key: 'school' },
  { label: 'Event', key: 'event' },
  { label: 'DivisionMale', key: 'divisionMale' },
  { label: 'Tr', key: 'tr' },
  { label: 'Dv', key: 'dv' },
  { label: 'Total', key: 'total' },
  { label: 'Gm', key: 'gm' },
  { label: 'Avg', key: 'avg' },
  { label: 'Pos', key: 'pos' },
  { label: 'Bwl', key: 'bwl' },
  { label: 'Tms', key: 'tms' },
  { label: 'Adiff', key: 'adiff' },
  { label: 'E', key: 'e' },
  { label: 'Top1', key: 'top1' },
  { label: 'Top5', key: 'top5' },
  { label: 'Top10', key: 'top10' },
  { label: 'Top25', key: 'top25' },
  { label: 'Pct', key: 'pct' }
]


// WEBPACK FOOTER //
// ./src/components/pages/Report/constants/eventByEventHeaders.js